import { customersApiClient } from './apiClient';

export const walletService = {
  async getBalance() {
    const result = await customersApiClient.get('/wallet/balance');

    if (!result.success) {
      return {
        success: false,
        balance: null,
        error: result.error || 'Failed to fetch wallet balance',
      };
    }

    return {
      success: true,
      balance: result.data || null,
      error: null,
    };
  },
};

export default walletService;
